import jwtDecode from "jwt-decode";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import USER_ROLES from "../../types/UserRoles";

export const useGetRole = () => {
  const user: any = useSelector((state: any) => state.auth.user);

  const data: any = useMemo(() => {
    return user && user.token ? jwtDecode(user.token) : {};
  }, [user]);

  const role = useMemo(() => {
    return data["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
  }, [data]);

  const isAdmin: boolean = useMemo(
    () => role !== USER_ROLES.PORTAL_USER,
    [role],
  );

  return [role, isAdmin, data];
};
